import { render, staticRenderFns } from "./SuccessPrompt.vue?vue&type=template&id=00f5393f&scoped=true&lang=html"
import script from "./SuccessPrompt.vue?vue&type=script&lang=js"
export * from "./SuccessPrompt.vue?vue&type=script&lang=js"
import style0 from "./SuccessPrompt.vue?vue&type=style&index=0&id=00f5393f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5393f",
  null
  
)

export default component.exports